module.exports = __webpack_public_path__ + "img/0Q3B3739_BlackMatted_MockedUp.7975c52f.jpg";